import { Flex } from 'antd'
import Image from '@/components/image'
import styles from './style.module.scss'

export default function Certificate({ images }: { images: string[] }) {
  if (!images?.length) return null

  return (
    <div className={styles.certificate}>
      <h2>Product certificate</h2>
      <Flex vertical className={styles.certificateList}>
        {images.map(image => (
          <Image key={image} src={image} alt='spec' className={styles.certificateItem} />
        ))}
      </Flex>
    </div>
  )
}
